<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.1164 19.3225L20.2532 21.4587C20.5624 21.7679 21.0639 21.7679 21.3731 21.4587C21.6824 21.1495 21.6824 20.6474 21.3731 20.3382L19.2514 18.2158C20.7176 16.5301 21.6053 14.328 21.6053 11.92C21.6053 6.62068 17.3037 2.3183 12.0043 2.3183C6.70491 2.3183 2.40234 6.62068 2.40234 11.92C2.40234 17.2193 6.70491 21.5217 12.0043 21.5217C14.3253 21.5217 16.456 20.6959 18.1164 19.3225ZM17.605 17.6537C19.0953 16.1975 20.021 14.166 20.021 11.92C20.021 7.49521 16.429 3.90292 12.0043 3.90292C7.57964 3.90292 3.98663 7.49521 3.98663 11.92C3.98663 16.3447 7.57964 19.9371 12.0043 19.9371C14.1721 19.9371 16.1408 19.0746 17.584 17.6745L17.5869 17.6716C17.593 17.6655 17.599 17.6595 17.605 17.6537ZM9.15993 16.6372C9.79245 15.7534 10.8274 15.1766 11.9953 15.1766C13.1723 15.1766 14.2141 15.7616 14.8447 16.6559C15.0969 17.0132 15.5913 17.0986 15.9486 16.8466C16.3059 16.5945 16.3919 16.0997 16.1397 15.7424C15.222 14.4417 13.7068 13.5919 11.9953 13.5919C10.2959 13.5919 8.79065 14.4298 7.87088 15.7151C7.61667 16.0708 7.69872 16.5661 8.05502 16.8205C8.41032 17.075 8.90571 16.9928 9.15993 16.6372ZM11.9953 6.84847C10.3289 6.84847 8.97579 8.2018 8.97579 9.86879C8.97579 11.5357 10.3289 12.889 11.9953 12.889C13.6627 12.889 15.0158 11.5357 15.0158 9.86879C15.0158 8.2018 13.6627 6.84847 11.9953 6.84847ZM11.9953 8.43309C12.788 8.43309 13.4315 9.07643 13.4315 9.86879C13.4315 10.6611 12.788 11.3044 11.9953 11.3044C11.2037 11.3044 10.5601 10.6611 10.5601 9.86879C10.5601 9.07643 11.2037 8.43309 11.9953 8.43309Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'StateSearching'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
